export type OrderServiceCoreServicesKinds = 'M_INN' | 'M_KUM' | 'M_SUM' | 'M_GAB' | 'M_OSO';

export const ORDER_SERVICE_CORE_SERVICES_KINDS: { [key in OrderServiceCoreServicesKinds]: OrderServiceCoreServicesKinds } = {
  M_INN: 'M_INN', // other
  M_KUM: 'M_KUM', // treatments
  M_SUM: 'M_SUM', // laboratory examinations
  M_GAB: 'M_GAB', // examinations
  M_OSO: 'M_OSO', // visits
};
